//Ionic Framework
import { Injectable } from '@angular/core';

//npm library
import { ALLOW_MULTIPLE_PLATFORMS } from '@angular/core/src/application_ref';


@Injectable()
export class SortingService {

	constructor() {
	}

	sortByString(array: any[], propName: string, acsending: boolean) {
        array.sort(function (a, b) {

            var aProp = a[propName];
            var bProp = b[propName];
            if(propName.indexOf(".") > -1) {
                let props = propName.split(".");
                if(props.length == 2) {
                    aProp = a[props[0]][props[1]];
                    bProp = b[props[0]][props[1]];
                }
                if(props.length == 3) {
                    aProp = (a[props[0]][props[1]] ? a[props[0]][props[1]][props[2]] : "");
                    bProp = (b[props[0]][props[1]] ? b[props[0]][props[1]][props[2]] : "");
                }
            }

            //handle sorting based of property values
            aProp = (aProp ? aProp.toString().toLowerCase() :"");
            bProp = (bProp ? bProp.toString().toLowerCase(): "");

            //handle sorting in cases of null properties
            if ((aProp == null || aProp == '') && (bProp != null && bProp != '')) {
                return 1;
            }
			if ((bProp == null || bProp == '') && (aProp != null && aProp != '')) {
                return -1;
            }
            if ((bProp == null && aProp == null) || (aProp == '' && bProp == '')) {
                return 0;
            }

            if (aProp < bProp) {
                if (acsending) {
                    return -1;
                }
                else {
                    return 1;
                }
            } else if (aProp > bProp) {
                if (acsending) {
                    return 1;
                }
                else {
                    return -1;
                }
            } else {
                return 0;
            }
        });
    }

    sortByArrayString(array: any[], acsending: boolean) {
        array.sort(function (a, b) {
            //handle sorting in cases of null properties
            if ((a== null || a == '') && (b != null && b != '')) {
                return 1;
            }
			if ((b == null || b == '') && (a != null && a != '')) {
                return -1;
            }
            if ((b == null && a == null) || (a == '' && b == '')) {
                return 0;
            }


            //handle sorting based of property values
            var aProp = (a ? a.toLowerCase() :"");
            var bProp = (b ? b.toLowerCase(): "");
            if (aProp < bProp) {
                if (acsending) {
                    return -1;
                }
                else {
                    return 1;
                }
            } else if (aProp > bProp) {
                if (acsending) {
                    return 1;
                }
                else {
                    return -1;
                }
            } else {
                return 0;
            }
        });
    }
    
    sortByDate(array: any[], propName: string, acsending: boolean) {
        array.sort(function (a, b) {
            //handle sorting in cases of null properties
            if (a[propName] == null && b[propName] != null) {
                return 1;
            }
            if (b[propName] == null && a[propName] != null) {
                return -1;
            }
            if (b[propName] == null && a[propName] == null) {
                return 0;
            }


            //handle sorting based of property values
            var aProp = new Date(a[propName]);
            var bProp = new Date(b[propName]);
            if (aProp < bProp) {
                if (acsending) {
                    return -1;
                }
                else {
                    return 1;
                }
            } else if (aProp > bProp) {
                if (acsending) {
                    return 1;
                }
                else {
                    return -1;
                }
            } else {
                return 0;
            }
        });
    }

    sortByPropertyNumber(array: any, propName: string, acsending: boolean) {
        array.sort(function (a, b) {
            var aProp = a[propName];
            var bProp = b[propName];
            if(propName.indexOf(".") > -1) {
                let props = propName.split(".");
                if(props.length == 2) {
                    aProp = a[props[0]][props[1]];
                    bProp = b[props[0]][props[1]];
                }
                if(props.length == 3) {
                    aProp = a[props[0]][props[1]][props[2]];
                    bProp = b[props[0]][props[1]][props[2]]; 
                }
            }

            //handle sorting in cases of null properties
            if (aProp == null && bProp != null) {
                return 1;
            }
            if (bProp == null && aProp != null) {
                return -1;
            }
            if (bProp == null && aProp == null) {
                return 0;
            }


            //handle sorting based of property values
            if (aProp < bProp) {
                if (acsending) {
                    return -1;
                }
                else {
                    return 1;
                }
            } else if (aProp > bProp) {
                if (acsending) {
                    return 1;
                }
                else {
                    return -1;
                }
            } else {
                return 0;
            }
        });
    }

    sortByPropertyStringWithArrayAsParamater(propName: string, acsending: boolean, array) {

        array.sort(function (a, b) {
            //handle sorting in cases of null properties
            if ((a[propName] == null || a[propName] == '') && (b[propName] != null && b[propName] != '')) {
                return 1;
            }
            if ((b[propName] == null || b[propName] == '') && (a[propName] != null && a[propName] != '')) {
                return -1;
            }
            if ((b[propName] == null && a[propName] == null) || (a[propName] == '' && b[propName] == '')) {
                return 0;
            }


            //handle sorting based of property values
            var aProp = a[propName].toLowerCase();
            var bProp = b[propName].toLowerCase();
            if (aProp < bProp) {
                if (acsending) {
                    return -1;
                }
                else {
                    return 1;
                }
            } else if (aProp > bProp) {
                if (acsending) {
                    return 1;
                }
                else {
                    return -1;
                }
            } else {
                return 0;
            }
        });
    }
    

	formatPhoneNumber(phone: string): string {
		if(phone) {
             phone = phone.replace("(","").replace("(","");
             phone = phone.replace(")","").replace(")","");
             phone = phone.replace("-","").replace("-","");
             phone = phone.replace("_","").replace("_","");
             phone = phone.replace("[","").replace("[","");
             phone = phone.replace("]","").replace("]","");
             phone = phone.replace("+","").replace("+","");
             phone = phone.replace(" ","").replace(" ","").replace(" ","").replace(" ","");
             if(phone.length <= 10 && phone.length >= 8) {
                phone = ('(' + phone.substring(0,3) + ') ' + phone.substring(3,6) + '-' + phone.substring(6,10));
             }
             else if(phone.length == 11) {
                phone = ('+' + phone.substring(0,1) + ' (' + phone.substring(1,4) + ') ' + phone.substring(4,7) + '-' + phone.substring(7,11));
             }
             else if(phone.length == 12) {
                phone = ('+' + phone.substring(0,2) + ' (' + phone.substring(2,5) + ') ' + phone.substring(5,8) + '-' + phone.substring(8,12));
             }
        }
        else {
            phone = "";
        }
		return phone;
    }
}